import * as React from 'react';
import { Translate } from '../../../../../shared/LanguageService';
import { Button, ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Dropzone from '../../../../../components/common/Dropzone';
import StoreyFileUploadModal from '../StoreyFileUploadModal';

interface IProps {
    thumbnailReference?: string;
    title: string;
    dropzoneId: string;
    actionUrl: string;
    upload: boolean;
    onUploadCompleted: () => void;
    onFileUploadCompleted: (response: any) => void;
    onUpload: () => void;

    onAnnotate: () => void;
    onEditTexts: () => void;
    onCompare: () => void;
    onClick: () => void;

    uploadModalTitle: string;
    showUploadModal: boolean;
    onShowUploadModal: () => void;
    onUploadModalClose: () => void;

    isAnnotation: boolean;
    displayTemplateGenerationButtons: boolean;
    isLocked: boolean;
}

const StoreyFile = (props: IProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <fieldset>
            <legend>{props.title}</legend>
            {props.thumbnailReference && (
                <div className="button-bar-below">
                    <div className="content-row">
                        <img
                            src={`${apiUrl}/file/${props.thumbnailReference}`}
                            onClick={props.onClick}
                        />
                        {props.isAnnotation && (
                            <i
                                className="material-icons image-action-warning"
                                title={Translate('order/plan/returned/annotation-title')}
                            >
                                feedback
                            </i>
                        )}
                    </div>
                    {!props.isLocked && (
                        <div className="button-row">
                            <ButtonGroup bsSize="sm">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-compare">
                                            <p>{Translate('order/plan/storey/compare-button')}</p>
                                        </Tooltip>
                                    }
                                >
                                    <Button bsStyle="default" onClick={props.onCompare}>
                                        <i className="material-icons no-label">photo_library</i>
                                    </Button>
                                </OverlayTrigger>

                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-annotate">
                                            <p>{Translate('order/plan/storey/annotate-button')}</p>
                                        </Tooltip>
                                    }
                                >
                                    <Button bsStyle="info" onClick={props.onAnnotate}>
                                        <i className="material-icons no-label">mode_edit</i>
                                    </Button>
                                </OverlayTrigger>

                                {props.displayTemplateGenerationButtons && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-edit-texts">
                                                <p>
                                                    {Translate(
                                                        'order/plan/storey/edit-texts-button'
                                                    )}
                                                </p>
                                            </Tooltip>
                                        }
                                    >
                                        <Button bsStyle="default" onClick={props.onEditTexts}>
                                            <i className="material-icons no-label">text_fields</i>
                                        </Button>
                                    </OverlayTrigger>
                                )}

                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-upload">
                                            <p>{Translate('order/plan/storey/upload-button')}</p>
                                        </Tooltip>
                                    }
                                >
                                    <Button bsStyle="info" onClick={props.onShowUploadModal}>
                                        <i className="material-icons no-label">cloud_upload</i>
                                    </Button>
                                </OverlayTrigger>
                            </ButtonGroup>
                        </div>
                    )}
                </div>
            )}
            {!props.thumbnailReference && (
                <div className="button-bar-below">
                    <div className="content-row">
                        {!props.isLocked && (
                            <Dropzone
                                dropzoneHtmlId={props.dropzoneId}
                                actionUrl={props.actionUrl}
                                upload={props.upload}
                                onUploadCompleted={props.onUploadCompleted}
                                onFileUploadCompleted={props.onFileUploadCompleted}
                                uploadMultiple={false}
                                maxFiles={1}
                                removeFileAfterSuccess={true}
                                acceptedFiles={'image/jpeg,image/png,image/gif,application/pdf'}
                            ></Dropzone>
                        )}
                    </div>
                    {!props.isLocked && (
                        <div className="button-row">
                            <ButtonGroup bsSize="sm">
                                <Button bsStyle="info" onClick={props.onUpload}>
                                    <i className="material-icons">cloud_upload</i>{' '}
                                    {Translate('order/plan/upload-button')}
                                </Button>
                            </ButtonGroup>
                        </div>
                    )}
                </div>
            )}

            {props.showUploadModal && (
                <StoreyFileUploadModal
                    title={props.uploadModalTitle}
                    dropzoneId={props.dropzoneId}
                    actionUrl={props.actionUrl}
                    upload={props.upload}
                    onUploadCompleted={props.onUploadCompleted}
                    onFileUploadCompleted={props.onFileUploadCompleted}
                    onUpload={props.onUpload}
                    closeModal={props.onUploadModalClose}
                />
            )}
        </fieldset>
    );
};

export default StoreyFile;
